/**
 * Supabase (PostgREST) lämnar högst 1 000 rader per anrop, utan fel. Listor
 * som kan bli längre (ordrar, användare, kunder, besök) hämtas därför sida
 * för sida tills en sida inte är full.
 *
 * `page` bygger en ny fråga för varje sida (supabase-js ändrar frågan när
 * man lägger till villkor) och måste ha en entydig sortering, t.ex.
 * `.order('id')`, så att ingen rad hoppas över eller kommer två gånger.
 */
export const PAGE_SIZE = 1000;

export interface PageResult<T> { data: T[] | null; error: unknown }

export const fetchAll = async <T>(page: (from: number, to: number) => PromiseLike<PageResult<T>>): Promise<T[]> => {
    const rows: T[] = [];
    for (let from = 0; ; from += PAGE_SIZE) {
        const { data, error } = await page(from, from + PAGE_SIZE - 1);
        if (error) throw error;
        const batch = data || [];
        rows.push(...batch);
        if (batch.length < PAGE_SIZE) return rows;
    }
};
